module.exports = __webpack_public_path__ + "static/media/left-round.c7610e12.svg";